import request from '@/utils/request'

export function queryRules(data) {
  return request({ url: '/api/booking-service/provisionRule/queryRules', method: 'post', data })
}

export function getRuleDetail(uuid) {
  return request({ url: '/api/booking-service/provisionRule/getRuleDetail', method: 'get', params: { uuid }})
}

export function saveRule(data) {
  return request({ url: '/api/booking-service/provisionRule/saveRule', method: 'post', data })
}

export function saveRules(data) {
  return request({ url: '/api/booking-service/provisionRule/saveRules', method: 'post', data })
}

export function updateRuleStatus(uuid, status) {
  return request({ url: '/api/booking-service/provisionRule/updateRuleStatus', method: 'post', params: { uuid, status }})
}

export function deleteRule(uuid) {
  return request({ url: '/api/booking-service/provisionRule/deleteRule', method: 'post', params: { uuid }})
}

export function queryEnabledPositionRules(stationName) {
  return request({ url: '/api/booking-service/provisionRule/queryEnabledPositionRules', method: 'get', params: { stationName }})
}

export function queryPersonGroups(data) {
  return request({ url: '/api/booking-service/provisionRule/queryPersonGroups', method: 'post', data })
}

export function getPersonGroupDetail(uuid) {
  return request({ url: '/api/booking-service/provisionRule/getPersonGroupDetail', method: 'get', params: { uuid }})
}

export function savePersonGroup(data) {
  return request({ url: '/api/booking-service/provisionRule/savePersonGroup', method: 'post', data })
}

export function deletePersonGroup(uuid) {
  return request({ url: '/api/booking-service/provisionRule/deletePersonGroup', method: 'post', params: { uuid }})
}

export function savePersonRuleConfig(userId, personalEnabled, overlapMode) {
  return request({
    url: '/api/booking-service/provisionRule/savePersonRuleConfig',
    method: 'post',
    params: { userId, personalEnabled, overlapMode }
  })
}

export function getPersonRuleConfig(userId) {
  return request({
    url: '/api/booking-service/provisionRule/getPersonRuleConfig',
    method: 'get',
    params: { userId }
  })
}

export function queryPersonCosts(data) {
  return request({ url: '/api/booking-service/provisionRule/queryPersonCosts', method: 'post', data })
}

export function getPersonCostDetail(uuid) {
  return request({ url: '/api/booking-service/provisionRule/getPersonCostDetail', method: 'get', params: { uuid }})
}

export function savePersonCostItem(data) {
  return request({ url: '/api/booking-service/provisionRule/savePersonCostItem', method: 'post', data })
}

export function batchSavePersonCostItems(data) {
  return request({ url: '/api/booking-service/provisionRule/batchSavePersonCostItems', method: 'post', data })
}
